/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectsMemberController', ProjectsMemberController);

    ProjectsMemberController.$inject = ['$scope', 'Lightbox', '$sce', '$http', '$stateParams', '$state', 'DateUtils', 'calendarConfig', 'moment'];

    function ProjectsMemberController ($scope, Lightbox, $sce, $http, $stateParams, $state, DateUtils, calendarConfig, moment) {
        var vm = this;
        vm.type = $stateParams.type;
        vm.setType = setType;
        vm.today = new Date().toISOString().split('T')[0];

        calendarConfig.i18nStrings.weekNumber = 'KW {week}';
        moment.locale("de", {
            week: {
                dow: 1
            }
        });

        vm.events = [];
        vm.overview = [];
        vm.placesToBook = false;
        getSbfTimeSlotsToBook();

        function getSbfTimeSlotsToBook() {
            return $http.get('api/member/sbf-time-slots/', {}).then(function(response) {
                var data = response.data.slots;
                var events = response.data.events;
                for(var i = 0; i < events.length; i++) {
                    for(var u = 0; u < events[i].slots.length; u++) {
                        events[i].slots[u].fromTime = DateUtils.convertDateTimeFromServer(events[i].slots[u].fromTime);
                        events[i].slots[u].toTime = DateUtils.convertDateTimeFromServer(events[i].slots[u].toTime);
                    }
                    events[i].untilDate = DateUtils.convertLocalDateFromServer(events[i].untilDate);
                    if (events[i].placesToBook > 0) {
                        vm.placesToBook = true;
                    }
                }

                vm.overview = events;
                vm.events = [];

                for(var i = 0; i < data.length; i++) {
                    data[i].fromTime = DateUtils.convertDateTimeFromServer(data[i].fromTime);
                    data[i].toTime = DateUtils.convertDateTimeFromServer(data[i].toTime);
                    var primaryColor = null;
                    var secondaryColor = null;
                    var freePlaces = data[i].freePlaces;
                    var booked = data[i].booked;

                    if(!booked) {
                        if(freePlaces === 0) {
                            freePlaces = "Ausgebucht";
                            primaryColor = '#d9534f';
                            secondaryColor = '#d9534f';
                        } else if(freePlaces === 1){
                            freePlaces = 1 + " freier Platz";
                            primaryColor = '#f0ad4e';
                            secondaryColor = '#f0ad4e';
                        } else {
                            freePlaces = freePlaces + " freie Plätze";
                            primaryColor = '#5cb85c';
                            secondaryColor = '#5cb85c';
                        }
                    } else {
                        freePlaces = "Bereits von dir gebucht";
                        primaryColor = '#d9534f';
                        secondaryColor = '#d9534f';
                    }

                    var event = {
                        title: data[i].project + " | " + freePlaces,
                        id: data[i].id,
                        startsAt: data[i].fromTime,
                        endsAt: data[i].toTime,
                        color: {
                            primary: primaryColor,
                            secondary: secondaryColor
                        }
                    };
                    vm.events.push(event);
                }
            });
        }

        vm.calendarView = 'month';
        vm.viewDate = new Date();

        vm.sbfClicked = function(event) {
            $state.go('book-sbf-slot', {'id': event.id});
        };

        loadAll();

        function loadAll () {
            $http.get('api/member/projects/', {params:{
                type: $stateParams.type
            }}).then(function(response) {
                vm.projects = response.data;
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        $scope.openLightboxModal = function(index, image) {
            var images = [{'url': image}];
            Lightbox.openModal(images, index);
        };

        function setType(type) {
            $state.go('member.projects', {
                type: type
            });
        }
    }
})();
